export const p6LoginUrl =
  process.env.REACT_APP_P6_LOGIN_URL ||
  'https://constructionandengineering.oraclecloud.com/ui/v1/login'
